<template lang="html">
  <div class="container-fluid">
    <div>
<table class="table table-hover table-sm" ref="doctafilelistble" :data="filelist">
  <thead>
    <div class = "row" slot="header">
      <h3 scope="col">
       Documents 
      </h3>
    </div>
    <tr>
      <th class="text-center" scope="col">Name</th>
      <th class="text-center" scope="col">Delete</th>
    </tr>
  </thead>
  <tbody>
        <tr v-for="(document, index) in filelist" :key="index">
          <td class="text-center" scope="row">
            <a :href="document.downloadpath">
            {{document.name}}
            </a>
          </td>
                    <td class="text-center" scope="row">
            <a @click.prevent="deleteItem(document.path, index)" href="">
            Delete
            </a>
          </td>
        </tr>
  </tbody>
  </table>
  </div>
<form>
  <div class="form-group" >
    <label for="exampleFormControlFile1">File Upload</label>
    <input type="file" ref="file" class="form-control-file" @change="uploadfile" id="exampleFormControlFile1">
  </div>
  <div v-if="progress" class="progress">
  <div class="progress-bar progress-bar-striped bg-info" role="progressbar" v-bind:style="progresswidth" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
</div>
 <span v-if="progress">{{progress}} %</span>
 
</form>


  </div>

</template>

<script>
import db from './firebaseInit'
import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/firestore');
require('@firebase/storage');


export default {
  name: 'documenttable',
  
  data () {
    return {
     filelist: [],
     progress: null,
     progresswidth: "width: 0%",
     response: 'Upload a file',
     file: ""
    }
  },
  created: function(){
    

  
  },
  mounted: function(){

this.loaddata()
  },
  methods: {
  loaddata: function(){
    var userId

  var user = firebase.auth().currentUser;
   if (user != null) {
      userId = user.uid;
      } 
var storageRef = firebase.storage().ref()
var listRef = storageRef.child('user/' + userId + '/vault')

listRef.listAll().then(res => {
  res.items.forEach(itemRef => {
    itemRef.getDownloadURL().then(url =>{

      const data = {
        'name' : itemRef.name,
        'path' : itemRef.fullPath,
        'downloadpath' : url
      } 
     this.filelist.push(data)
     //console.log(filelist)
     })
  });
})

    },
    uploadfile: function(e) {
    var user = firebase.auth().currentUser;
  var userId
   if (user != null) {
      userId = user.uid;
      } 
      this.file = this.$refs.file.files[0]
      var file = this.file
      
var storageRef = firebase.storage().ref('user/' + userId + '/vault/' + file.name)

var task = storageRef.put(file)
console.log(this.response);
task.on('state_changed',
snapshot => {
  this.progress = ((snapshot.bytesTransferred / snapshot.totalBytes) * 100).toFixed(0);
  this.progresswidth = 'width: ' + this.progress + '%'
  //this.response = 'Uploading: ' + this.progress + '%'
  console.log(this.response);
  
},
err => {
},
() => {
    task.snapshot.ref.getDownloadURL().then(downloadURL => {
    const data = {
        'name' : task.snapshot.ref.name,
        'path' : task.snapshot.ref.fullPath,
        'downloadpath' : downloadURL
      }
      console.log(data)
      this.filelist.push(data)
      this.response = 'File Uploaded'
      this.progress = null
      this.progresswidth = 'width: 0%'
  });

}
)

    },

    downloadItem: function(url){
var xhr = new XMLHttpRequest();
  xhr.responseType = 'blob';
  xhr.onload = function(event) {
    var blob = xhr.response;
  };
  xhr.open('GET', url);
  xhr.send();

    },
    deleteItem: function(url, index){
  var storageRef = firebase.storage().ref()
// Create a reference to the file to delete
var fileRef = storageRef.child(url);

// Delete the file
fileRef.delete().then(function() {
      console.log(index);

}).catch(function(error) {
  // Uh-oh, an error occurred!
});
  this.filelist.splice(index, 1);
    }
  },
  computed: {

   
  }

}
</script>